<script setup>
/**
 * FormControlUsersAllowCacheClearance
 */
import {computed} from 'vue'
import {useUserStore} from '@/stores/user'
import FormControlTypeCheckbox from '@/common/form-control-type/FormControlTypeCheckbox.vue'

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
})

// Pinia Store
const userStore = useUserStore()

const user = computed(() => userStore.user)

// Apply visibility and disabled logic
if (!user.value?.administrator) {
    props.field.hidden = true
} else if (user.value.id === props.currentData.id) {
    // Administrators cannot edit themselves.
    // This ensures that there is always one administrator because the last administrator
    // must assign someone else as an administrator before they can be removed.
    props.field.disabled = true
}
</script>

<template>
    <FormControlTypeCheckbox
        :form-id="formId"
        :field="field"
        :current-data="currentData"
    />
</template>